// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OERateDataModel } from "./oe-rate-data.model";
import { RateSubscription } from "shared/cubiq-services";

export class OEIncomingRateSubscriptionModel {
  public subscrKey: string; // example EURUSD-MARKET-SPOT
  public rateSubscription: RateSubscription;
  // ccyPair subscribed to the worker, can not be invert
  public subscribedCcyPair: string = null;
  public ccyPairModel: CubiqTS.CurrencyPairImpl = null;
  //
  public lastValue: OERateDataModel = null;
  public value: OERateDataModel;

  constructor(subscrKey: string, rateSubscription: RateSubscription) {
    if (typeof subscrKey === "string" && rateSubscription instanceof RateSubscription) {
      this.subscrKey = subscrKey;
      this.rateSubscription = rateSubscription;
    } else {
      throw new Error(`Invalid rate key or subscription`);
    }
  }
}
